import {
    ILocationKcfInformationResponse,
    ILocationKcfInformationUpdateRequest,
    ILocationResponse,
    ILocationUpdateRequest,
    LocationKcfInformationUpdateRequest,
    LocationUpdateRequest,
} from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';

function createUpdateResponse(location: ILocationResponse): ILocationUpdateRequest {
    return {
        IsActive: location.Active,
        CorporationId: location.Corporation.CorporationId,
        Name: location.Name,
        Abbreviation: location.Abbreviation,
        MaxOilQualityUpdateInterval: location.Settings.MaxOilQualityUpdateInterval,
        MaxVibrationUpdateInterval: location.Settings.MaxVibrationUpdateInterval,
        MaxTransportInterval: location.Settings.MaxTransportInterval,
        OpcEnabled: location.Settings.OpcEnabled,
        ExternalNotificationType: location.Settings.ExternalNotificationType,
        LineFrequency: location.Settings.LineFrequency,
        SubscriptionService: location.Settings.SubscriptionService,
        AutoCreateMaintenanceTask: location.AutoCreateMaintenanceTask,
        DynamicSystemsAllowedForDesk: location.DynamicSystemsAllowedForDesk,
        DraftIssuesAvailableToCustomerAdmins:
            location.Settings.DraftIssuesAvailableToCustomerAdmins,
        ModelPublication: location.Settings.ModelPublication,
    };
}

export async function updateLocation(
    location: ILocationResponse,
    updates: Partial<ILocationUpdateRequest>
) {
    const initialValue = createUpdateResponse(location);
    return sdClient.updateLocation({
        id: location.Id,
        body: new LocationUpdateRequest({ ...initialValue, ...updates }),
    });
}

export async function updateLocationKcfInformation(
    locationId: string,
    currentValue: ILocationKcfInformationResponse,
    updates: Partial<ILocationKcfInformationUpdateRequest>
) {
    return sdClient.updateLocationKcfInformation({
        id: locationId,
        body: new LocationKcfInformationUpdateRequest({
            NetSuiteId: currentValue.NetSuiteId,
            ...updates,
        }),
    });
}
